import { render, staticRenderFns } from "./form-block-update-admin.vue?vue&type=template&id=59cd75a0&"
import script from "./form-block-update-admin.vue?vue&type=script&lang=js&"
export * from "./form-block-update-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports